import { render, staticRenderFns } from "./InventoryInTrace.vue?vue&type=template&id=43faac13&scoped=true&"
import script from "./InventoryInTrace.vue?vue&type=script&lang=js&"
export * from "./InventoryInTrace.vue?vue&type=script&lang=js&"
import style0 from "./InventoryInTrace.vue?vue&type=style&index=0&id=43faac13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43faac13",
  null
  
)

export default component.exports